/* eslint-disable arrow-body-style */
/* eslint-disable react/prop-types */
import React from 'react';
import Lottie from "lottie-react";
import iconCheck from './IconCheck_NoLoop_01.json';

const IconCheck = (props) => {
    return (
        <Lottie animationData={JSON.parse(JSON.stringify(iconCheck))} {...props}/>
    );
}

export default IconCheck;



// WEBPACK FOOTER //
// ./frontend/pages/LiveMarkets/animations/howItWorksIcons/iconCheck.jsx